module.exports = __webpack_public_path__ + "img/case1.1f983d1e.png";